import { createReducer, on } from '@ngrx/store';
import { NotesApiActions } from './notes.actions';
import { adapter, NotesState, initialState, selectIdFromNote } from './notes.state';

export const notesReducer = createReducer(
  initialState,
  on(
    NotesApiActions.notesLoaded,
    (state, { notes, udid }): NotesState =>
      adapter.upsertMany(
        notes.map((x) => {
          return { ...x, udid };
        }),
        state
      )
  ),
  on(NotesApiActions.noteAdded, (state, { note, udid }): NotesState => adapter.upsertOne({ ...note, udid }, state)),
  on(NotesApiActions.noteDeleted, (state, { note }): NotesState => adapter.removeOne(selectIdFromNote(note), state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectNotesIds = selectIds;

export const selectNotesEntities = selectEntities;

export const selectAllNotes = selectAll;
